import { Card, Stack } from '@mui/material';
import { CustomData } from '@occc-app/routes/CampaignComponents/components/CustomData/CustomData';
import { CampaignComponentFooterActions } from '@occc-app/routes/CampaignComponents/components/CampaignComponentFooterActions';
import { CampaignComponentReadOnlyFooterActions } from '@occc-app/routes/CampaignComponents/components/CampaignComponentReadOnlyFooterActions';
import { OfferContentDesignSection } from '@occc-app/offerHelpers/DesignForm/OfferContentDesignSection';
import { AdditionalInformationDesignSection } from '@occc-app/offerHelpers/DesignForm/AdditionalInformationDesignSection';
import { OfferFundingDesignSection } from '@occc-app/offerHelpers/DesignForm/OfferFundingDesignSection';
import { PresentationDesignSection } from '@occc-app/offerHelpers/DesignForm/PresentationDesignSection';

import { Offer_Presentation_Type } from '@occc/graphql';
import { Flow_Types } from '@occc-app/offerHelpers/types';
import { FormLayout } from '@occc-app/routes/CampaignComponents/components/FormLayout';
import { DesignFormRenderProps } from '../../types';

type DesignFormContentProps = {
  handleNextButtonClick: () => void;
  isReadOnlyRole: boolean;
  currentFlowType: Flow_Types;
  orderAheadEnabled: boolean;
  submitting?: boolean;
  dirty?: boolean;
  values: DesignFormRenderProps['values'];
  handleCancel?: () => void;
  isLoading?: boolean;
};

export const DesignFormContent = ({
  values,
  isReadOnlyRole,
  currentFlowType,
  orderAheadEnabled,
  handleNextButtonClick,
  handleCancel,
  submitting,
  dirty,
  isLoading,
}: DesignFormContentProps) => {
  const formFooterActionButtons = isReadOnlyRole ? (
    <CampaignComponentReadOnlyFooterActions
      onCancel={handleCancel}
      onNextStepClick={handleNextButtonClick}
    />
  ) : (
    <CampaignComponentFooterActions
      currentFlowType={currentFlowType}
      onCancel={handleCancel}
      isSubmitDisabled={submitting || (currentFlowType === Flow_Types.Update && !dirty)}
    />
  );

  return (
    <FormLayout actions={formFooterActionButtons} type='primary' isLoading={isLoading}>
      <Stack spacing={1}>
        <Stack p={1.5} spacing={1} component={Card}>
          <OfferContentDesignSection marketingContent={values.marketingContent} />
          <AdditionalInformationDesignSection showSurgeonGeneralsWarning />
          <PresentationDesignSection
            presentationTypeEnabled
            displayCategoriesEnabled={
              values.offer?.presentationType === Offer_Presentation_Type.Default
            }
            orderAheadEnabled={orderAheadEnabled}
            presentationTypeOptions={[
              { value: Offer_Presentation_Type.Default, label: 'Tile' },
              { value: Offer_Presentation_Type.Hidden, label: 'Hidden' },
            ]}
          />
          <OfferFundingDesignSection />
        </Stack>

        <CustomData values={values.customData} label='Marketing Custom Data' />
      </Stack>
    </FormLayout>
  );
};
